import React from 'react';
import {fetchFeedbackMovement} from '../services';
import Fetch from "../Elements/Fetch";
import {FeedbackMovement} from './FeedbackMovement';

// @ts-ignore
const FeedbackMovementRoute = ({match}) => {
    const id = match.params.id;

    return (
        <Fetch
            fetchFunction={fetchFeedbackMovement}
            fetchFunctionParams={id}
            refreshKey={`feedback-movement:${id}`}
        >
            {(movement: any) => <FeedbackMovement {...movement} id={id}/>}
        </Fetch>
    );
};

export default FeedbackMovementRoute;
